import React, { useContext } from 'react'
import styled from 'styled-components'

import { Link } from '@Components/Link'
import { TrustIconCH } from '@Components/TrustIcons/TrustIconCH'
import { TrustIconDE } from '@Components/TrustIcons/TrustIconDE'
import { TrustIconFR } from '@Components/TrustIcons/TrustIconFR'
import { TrustIconsNL } from '@Components/TrustIcons/TrustIconsNL'
import { NavigationEvent } from '@Events/Navigation'
import { MetadataContext } from '@Globals/Metadata'
import { flexCenterChildren } from '@Globals/Style/mixins'

const NormalFooter = styled.div`
  ${flexCenterChildren}
  padding: 80px 0px 120px;
  img {
    margin: 0 auto;
    width: 70%;
  }
`

export type Variant = 'mobile-menu' | 'footer'

interface TrustIconsProps {
  variant: Variant
}

export const TrustIcons = ({ variant }: TrustIconsProps) => {
  const { store, storeURL } = useContext(MetadataContext)

  if (store?.id === '5') {
    return <TrustIconsNL variant={variant} />
  }

  if (store?.id === '7') {
    return <TrustIconDE variant={variant} />
  }

  if (store?.id === '10') {
    return <TrustIconFR variant={variant} />
  }

  if (store?.id === '19' || store?.id === '20') {
    return <TrustIconCH variant={variant} />
  }

  // we only show trendhim Logo for mobile-menu
  if (variant !== 'mobile-menu') {
    return null
  }

  return (
    <NormalFooter>
      <Link
        event={
          new NavigationEvent({
            attributes: {
              dest_page_type: 'frontpages',
              dest_page_type_id: '',
              source_id: 'mobile_menu_footer',
            },
            eventName: 'nav_link_click',
          })
        }
        href={storeURL('/')}
      >
        <img
          alt="Trendhim"
          src="https://res.cloudinary.com/trendhim/image/upload/v1570536495/frontend/trendhim-logo-with-text.svg?v3"
        />
      </Link>
    </NormalFooter>
  )
}
